import { useState } from 'react';
import type { CreateScheduledPaymentRequest, CreateScheduledPaymentResponse } from 'vopay';
import { api } from '@/services/api.config';

export default function useCreateScheduledPayment() {
  const [submitting, setSubmitting] = useState(false);

  async function createScheduledPayment(
    params: CreateScheduledPaymentRequest,
  ): Promise<CreateScheduledPaymentResponse> {
    try {
      setSubmitting(true);
      const res = await api.createScheduledPayment(params);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, createScheduledPayment };
}
